/**
 * Presentation and permission helpers for Workflow Tracking.
 *
 * Kept outside the JSX route so the status and identity safeguards can be tested with
 * the lightweight node:test setup used by the web workspace.
 */

export function displayUserName(names, uid, emptyLabel = '—', fallbackName = '') {
  if (!uid) return fallbackName || emptyLabel;
  return names?.[uid] || fallbackName || 'Unknown user';
}

/** A reminder is valid only while the parent matter is actively in its approval flow. */
export function canRemindPendingStep({ canSendReminder, matterStatus, stepStatus }) {
  return Boolean(
    canSendReminder &&
      matterStatus === 'pending_approval' &&
      stepStatus === 'pending'
  );
}
